import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import _ from "lodash";
import Firebase from "firebase";
import {
    CCActivityIndicator,
    CCEntrySummaryItem,
    Constants,
    CCCoinPile,
    CCAppEventLogger,
    CCButton,
    colors,
    strings,
    DataActionTypes as DataAT,
    CCActions,
    CCBackLayout
} from "./../../cc-imports";
import './../../styles/css/screens/SingleLeague/single-league.css'

import PropTypes from "prop-types";

const totalSalary = 10000;
const playersPerTeam =2;

class SingleLeague extends Component {

    static propTypes = {
        onPlayPressed : PropTypes.func,
        league : PropTypes.object
    }

    static defaultProps = {
        onPlayPressed: ()=>{}
    }


    constructor(props) {
        super(props);
        this.initialState={
            league: {},
            userEntries: undefined,
            allEntries : [],
            screen : 'league',
            skip:0,
            win : 0,
            lost :0,
            refunded:0
        }
        this.state = this.initialState;

       this._updateEntries=this._updateEntries.bind(this);
       this._fetchEntries=this._fetchEntries.bind(this);
       this._getFirstText=this._getFirstText.bind(this);
       this._getSecondText=this._getSecondText.bind(this);
       this._getMyEntryFirstText=this._getMyEntryFirstText.bind(this);
       this._isLeagueCompleted=this._isLeagueCompleted.bind(this);
       this.__isLeagueStartedOrCompleted=this.__isLeagueStartedOrCompleted.bind(this);
       this._showAllEntries=this._showAllEntries.bind(this);
       this._showLeague=this._showLeague.bind(this);
       this._paginate=this._paginate.bind(this);
       this._manualRefresh=this._manualRefresh.bind(this);
       this._closeModal=this._closeModal.bind(this);
       this._playLeague=this._playLeague.bind(this);
    }

    _updateEntries(){

        const {entriesByLeague,entriesById, userId} = this.props;

        var entryIdsForLeague = entriesByLeague[this.state.league.id];
        var allEntries = [];

        _.forEach(entryIdsForLeague,(entryId)=>{
            allEntries.push(entriesById[entryId]);
        });

        allEntries = _.sortBy(allEntries,["rank"])

        var userEntries = [];

        if(userId){
            userEntries = _.filter(allEntries,(entry)=>{
                return entry.creator.id==userId
            });
        }

        var win=0, lost=0, refunded=0;

        _.forEach(userEntries, (entry)=>{
            if(entry.winning){
                win = win + entry.coinsEarned;
            }
            else if(entry.status==Constants.entryStatus.COMPLETED && !entry.winning){
                lost = lost+entry.coins;
            }
            else {
                refunded = refunded+entry.coins;
            }
        })

        this.setState({userEntries,allEntries, win, lost, refunded})
    }

    _showAllEntries(){
        const {userId} = this.props;
        if(this.state.league){
            const league = this.state.league;
            CCAppEventLogger.logAppEvent("ShowAllEntries",{   'league_category':league.category,
                'league_type':league.type,
                'match_key':league.match.key,
                loggedIn:userId
            })
        }
        this.setState({
            screen : 'entries'
        })
    }

    _showLeague(){
        this.setState({
            screen : 'league'
        })
    }

    _manualRefresh(){
        this._fetchEntries(this.state.league,DataAT.MANUAL_REFRESH);
    }

    _paginate() {
        const {entriesReqStatus,userId} = this.props;
        if (entriesReqStatus != Constants.reqStatus.FAI && entriesReqStatus != Constants.reqStatus.COM) {
            const {league, skip} = this.state;
            this._fetchEntries(league, DataAT.PAGINATE, () => {
                this.setState({skip: skip + 1});
            });
        }


    }

    _fetchEntries(league, type, callback){
        //console.log('fetching entries in league ------- ', type)
        Firebase.auth().currentUser && Firebase.auth().currentUser.getIdToken(false).then((idToken) => {
            const {entriesPages} = this.props;

            var userId = this.props.userId? this.props.userId : Constants.anonymousUser;

            var page = entriesPages[league.id] == undefined ? 0 : entriesPages[league.id];
            var skip = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? 0 : page;
            var limit = (type == DataAT.AUTO_REFRESH || type == DataAT.MANUAL_REFRESH) ? page * 20 : 20;

            var promises = [];

            if(type!=DataAT.PAGINATE){
                promises.push( this.props.actions.getEntriesByUserIdAndLeagueId({
                    userId: userId,
                    leagueId : league.id
                }, {
                    accessToken: idToken,
                    userId: userId
                }, type));
            }

            promises.push(this.props.actions.getEntriesByLeagueId({
                leagueId: league.id,
                skip: skip,
                limit: limit
            }, {
                accessToken: idToken,
                userId: userId
            }, type, league.id).then(() => {

            }));

            Promise.all(promises).then(()=>{
                this._updateEntries();
                callback && callback();
            })
        })
    }

    componentDidMount(){
        //console.log("single league component mount -------")
        const {league}=this.props;
        if(!_.isEqual(league, this.state.league)){
            this._fetchEntries(league, DataAT.GET);
            this.setState({league : league});
        }
    }

    componentWillUnmount(){
    }

    _getFirstText(entry){
        return entry.creator.displayName;
    }

    _getSecondText(entry) {
        if(entry.league.category!=Constants.leagueCategory.DREAMTEAM){
            if(entry.status == Constants.entryStatus.COMPLETED) {
                return '#'+entry.rank +' : '+entry.prediction;
            }
            else if(entry.status==Constants.entryStatus.LIVE) {
                return entry.prediction;
            }
            else{
                return;
            }
        }
        else {
            if(entry.status==Constants.entryStatus.LIVE||entry.status==Constants.entryStatus.COMPLETED){
                return '#'+entry.rank+' ('+entry.score+')';
            }
            else {
                return;
            }
        }
    }

    _getMyEntryFirstText(entry, league) {
        if(entry.league.category!=Constants.leagueCategory.DREAMTEAM){
            if(entry.status==Constants.entryStatus.COMPLETED){
                return '#'+entry.rank + ' : ' + entry.prediction;
            }
            else {
                return entry.prediction;
            }
        }
        else {
            if(entry.status==Constants.entryStatus.LIVE||entry.status==Constants.entryStatus.COMPLETED){
                return '#'+entry.rank+' ('+entry.score+')';
            }
            else {
                return;
            }
        }
    }

    _isLeagueCompleted(league){
        return !(league.status==Constants.leagueStatus.NOT_STARTED|| league.status==Constants.leagueStatus.LIVE);
    }

    __isLeagueStartedOrCompleted(league){
        return league.status!=Constants.leagueStatus.NOT_STARTED;
    }

    _closeModal() {
        //console.log( this.props.actions.closeModal)
        this.props.actions.closeModal("SingleLeagueModal");
    }

    _playLeague() {
        this.props.onPlayPressed();
    }

    _getTitles(league){
        var titles = {};
        const qpd = league.quickPredictionDetails;
        switch (league.category){
            case Constants.leagueCategory.DREAMTEAM:
                titles.title = strings('dream_team_leagues');
                titles.description = strings('dream_team_description')
                break;
            case Constants.leagueCategory.PREDICTION:
                titles.title = strings('target_prediction_leagues');
                titles.description = strings('target_prediction_description')
                break;
            case Constants.leagueCategory.LIVE_PREDICTION:
                titles.title = strings('live_prediction_leagues');
                titles.description = strings('live_prediction_description', {teamName:qpd.team.toUpperCase(), startOver : qpd.startOver, endOver:qpd.endOver})
                break;
        }
        return titles;
    }


    render() {
        const titles = this._getTitles(this.state.league);
        const styles = ccStyles.default;

        const{allEntries}=this.state;
        const {entriesType,entriesReqStatus}=this.props;

        return (
            <div style={{height:'100%'}}>
                <div className={"flex-container"} style={{flex : 1, flexDirection:'column'}}>
                    <div className={"flex-container single-league-title-container"}>
                        <h1 className={'single-league-title-txt'}>{titles.title}</h1>
                    </div>
                    {
                        this.state.screen=='league' ?
                            <div className={"flex-container"} style={{flex:1, flexDirection:'column'}}>
                                {
                                    (this._isLeagueCompleted(this.state.league) && this.state.userEntries && this.state.userEntries.length>0) ?
                                        <div className={"flex-container single-league-section-container section1"}>
                                            {
                                                (this.state.refunded > 0) ?
                                                    <div className={"flex-container"} style={{ flex:1, flexDirection:'column',justifyContent:'center', alignItems:'center', margin:'.1vw'}}>
                                                        <h1 className={'single-league-title1'}>{strings('refunded_title')}</h1>
                                                        <CCCoinPile textClass={'s-league-cp-font'} iconClass={'s-league-cp-icon'}  coins={this.state.refunded}/>
                                                    </div>
                                                    :
                                                    <div className={"flex-container"} style={{flex:1, flexDirection:'row', marginTop:'.2vw'}}>
                                                        <div className={"flex-container"} style={{ flex:1, flexDirection:'column',justifyContent:'center', alignItems:'center', margin:'.1vw'}}>
                                                            <h1 className={'single-league-title1'} >{strings('you_won')}</h1>
                                                            <CCCoinPile textClass={'s-league-cp-font'} iconClass={'s-league-cp-icon'} coins={this.state.win}/>
                                                        </div>
                                                        <div className={"flex-container"} style={{ flex:1, flexDirection:'column',justifyContent:'center', alignItems:'center'}}>
                                                            <h1 className={'single-league-title1'} >{strings('you_lost_message')} </h1>
                                                            <CCCoinPile textClass={'s-league-cp-font'} iconClass={'s-league-cp-icon'} coins={this.state.lost}/>
                                                        </div>
                                                    </div>

                                            }
                                        </div>
                                        :
                                        <div className={"flex-container single-league-section-container"} >
                                            <h3 className={'single-league-description1'} >{titles.description} </h3>
                                        </div>

                                }
                                <div className={"flex-container single-league-section-container divider"}/>
                                {
                                    (entriesType==DataAT.GET && entriesReqStatus==Constants.reqStatus.PEN)?
                                        <div className={"flex-container"} style={{alignItems:"center",justifyContent:'center'}}>
                                            <CCActivityIndicator size={'s'}/>
                                        </div>
                                        :
                                        <div className={'flex-container'} style={{flex:1}}>
                                            {
                                                this.state.userEntries != undefined &&
                                                <div className={"flex-container"} style={{flex:1}}>
                                                    {
                                                        this.state.userEntries.length > 0 ?
                                                            <div className={"flex-container"} style={{flex:1, justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
                                                                <h3 className={'single-league-title1'} style={{textAlign:'center'}}>{strings('your_entries')} </h3>
                                                                <div className="flex-container entry-dp">
                                                                {
                                                                    this.state.userEntries.map((entry) => <CCEntrySummaryItem  size={styles.entrySummarySize} firstText={this._getMyEntryFirstText(entry, this.state.league)}  entry={entry} key={entry.id}></CCEntrySummaryItem>)
                                                                }
                                                                </div>

                                                            </div>
                                                            :
                                                            <div className={"flex-container"} style={{flex:1, marginTop:'.2vw', justifyContent:'center', alignItems:'center'}}>
                                                                <h3 className={'single-league-description1'}>{strings('cant_placed_entries')} </h3>
                                                            </div>
                                                    }
                                                </div>

                                            }
                                        </div>
                                }
                                <div className={"flex-container single-league-section-container divider"}/>
                                <div className={"flex-container"} style={{flexDirection:'column', flex:1}}>
                                    <h3 className={'all_entries_title'}>{strings('all_entries')}</h3>
                                    {
                                        (entriesReqStatus==Constants.reqStatus.PEN && entriesType==DataAT.GET) ?
                                            <div className={'flex-container'} style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                                                <CCActivityIndicator size={"s"}/>
                                            </div>
                                            :
                                            <div className="flex-container no_of_entries_container">
                                                {
                                                    _.slice(this.state.allEntries, 0, 4).map((entry, index)=>{
                                                        return( <CCEntrySummaryItem  size={styles.entrySummarySize} onPress={index==3?this._showAllEntries:()=>{}} firstText={this._getFirstText(entry)} secondText={this._getSecondText(entry)} placeholder={index==3} placeholderText={'+'+(this.state.league.noOfEntries- 3)}  entry={entry} key={entry.id}></CCEntrySummaryItem>)
                                                    })
                                                }
                                            </div>
                                    }
                                </div>
                                <div className={"flex-container  single-league-section-container section4"}>
                                    {
                                        this.__isLeagueStartedOrCompleted(this.state.league)?
                                            <div className={"flex-container"} style={{justifyContent:'center',alignItems:'center',marginTop:5}}>
                                                <CCButton titleClassName={"button_text"} className={"btn-style"} onPress={this._closeModal} title={strings('close')}/>
                                            </div>
                                            :
                                            <div className={"flex-container"} style={{justifyContent:'center',alignItems:'center',marginTop:10}}>
                                                <CCButton titleClassName={"button_text"} className={"btn-style"} onPress={()=>{this._playLeague(this.state.league)}} title={strings('play_button')}/>
                                            </div>
                                    }
                                </div>

                            </div>
                            :
                            <div className={"flex-container single-league-entries-container "} >
                                <CCBackLayout onBackPress={this._showLeague}>
                                    <div className={"scroll"}>
                                    {
                                        (entriesType== DataAT.MANUAL_REFRESH && entriesReqStatus==Constants.reqStatus.PEN) ?
                                            <div style={{flex:1, alignItems:'center', justifyContent:'center'}}>
                                                <CCActivityIndicator size={"m"}/>
                                            </div>
                                            :
                                            <div className="gridView flex-container " style={{ justifyContent:'center' }}>
                                                {
                                                    allEntries.map((entry)=>{
                                                        return( <CCEntrySummaryItem size={styles.entrySummarySize} firstText={this._getFirstText(entry)} secondText={this._getSecondText(entry)}  entry={entry} key={entry.id}></CCEntrySummaryItem>)
                                                    })
                                                }
                                            </div>
                                    }
                                </div>
                                </CCBackLayout>
                            </div>
                    }
                </div>
            </div>
        )
    }
}

export default connect(state => ({
        modals: state.modals,

        user: state.user.user,
        userId: state.user ? state.user.user ? state.user.user.id : undefined : undefined,

        entries: state.entries,
        entriesById : state.entries.byId,
        entriesByLeague : state.entries.byLeague,
        entriesByCreatorId : state.entries.byCreatorId,
        entriesPages : state.entries.pages,
        entriesReqStatus : state.entries.reqStatus,
        entriesError : state.entries.error,
        entriesType : state.entries.type,

        matches : state.matches
    }),
    (dispatch) => ({
        actions: bindActionCreators({...CCActions}, dispatch),
        dispatch: dispatch
    })
)(SingleLeague);


const ccStyles = {
    default:{
        entrySummarySize : 'r',
        noEntryTitle : {
            fontSize:20
        }
    },
    s : {
        entrySummarySize:'s',
        noEntryTitle : {
            fontSize:16
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/screens/SingleLeague/SingleLeague.js